// initCornerstone.ts
import * as cornerstone from 'cornerstone-core'
import * as cornerstoneWADOImageLoader from 'cornerstone-wado-image-loader'
import * as dicomParser from 'dicom-parser'

let initialized = false

export function initCornerstone() {
  if (initialized) return
  initialized = true

  cornerstoneWADOImageLoader.external.cornerstone = cornerstone
  cornerstoneWADOImageLoader.external.dicomParser = dicomParser

  cornerstoneWADOImageLoader.webWorkerManager.initialize({
    webWorkerPath: '/cornerstoneWADOImageLoaderWebWorker.js',
    taskConfiguration: {
      decodeTask: {
        codecsPath: '/cornerstoneWADOImageLoaderCodecs.js',
      },
    },
    maxWebWorkers: 2
  })
}
